(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-related-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const productRecommendationsSection = document.querySelector('.product-recommendations');

    if (!productRecommendationsSection) return;
    const url = productRecommendationsSection.dataset.url;
    if (productRecommendationsSection.dataset.manual == 'true') return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newRecommendations = doc.querySelector('.product-recommendations');

        if (newRecommendations) {
          productRecommendationsSection.innerHTML = newRecommendations.innerHTML;

          // Dynamically load custom-slider.js
          const script = document.createElement('script');
          script.src = window.customSliderScriptUrl; // Use the globally defined variable
          script.defer = true;
          document.body.appendChild(script);
        }
      })
      .catch((e) => {
        console.error('Error loading recommendations:', e);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-store-locator"] && !Shopify.designMode) return;
  try {
    
  let map;

  async function initMap() {
    const { Map, InfoWindow } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary('marker');

    map = new Map(document.getElementById('map'), {
      center: { lat: 12.236908, lng: 122.556934 },
      zoom: 6,
      mapId: 'DEMO_MAP_ID', // Replace with your map ID if needed
    });

    const bounds = new google.maps.LatLngBounds();
    const storeElements = document.querySelectorAll('.store-item');

    storeElements.forEach((store) => {
      const lat = parseFloat(store.dataset.lat);
      const lng = parseFloat(store.dataset.lng);
      const name = store.dataset.name;
      const address = store.dataset.address;
      const phone = store.dataset.phone;
      const email = store.dataset.email;
      const hours = store.dataset.hours;
      const hoursLong = JSON.parse(store.dataset.hours_long || '[]');

      if (isNaN(lat) || isNaN(lng)) return; // Skip stores with invalid lat/lng

      const pin = new PinElement({
        borderColor: '#84754f',
        background: '#84754f',
        glyphColor: 'white',
      });

      const marker = new AdvancedMarkerElement({
        position: { lat, lng },
        map,
        title: name,
        content: pin.element,
        gmpClickable: true,
      });

      let hoursLongContent = '';
      if (hoursLong && hoursLong.length > 0) {
        hoursLongContent =
          '<div class="store-item__hours" style="display: grid; grid-template-columns: auto 1fr; gap: 5px 10px;">';
        hoursLong.forEach((hour) => {
          if (typeof hour === 'string') {
            const parts = hour.trim().match(/^(\S+)\s+(.+)$/);
            if (parts) {
              const [_, day, time] = parts;
              hoursLongContent += `
          <h4 style="font-weight: bold;">${day}</h4>
          <h4>${time}</h4>
        `;
            }
          }
        });
        hoursLongContent += '</div>';
      }

      let infoWindowContent = `
      <div style="max-width: 300px;"> 
        <h3 style="margin-bottom: 10px;">${name || ''}</h3>
        <div style="display: grid; grid-template-columns: auto 1fr; gap: 5px 10px; align-items: start;">
          ${address ? `<h4><strong>Address:</strong></h4> <h4>${address}</h4>` : ''}
          ${phone ? `<h4><strong>Phone:</strong></h4> <h4>${phone}</h4>` : ''}
          ${email ? `<h4><strong>Email:</strong></h4> <h4>${email}</h4>` : ''}
          ${hours ? `<h4><strong>Hours:</strong></h4> <h4>${hours}</h4>` : ''}
          ${
            hoursLongContent
              ? `<h4 style="font-weight: bold;">Hours:</h4> <div style="grid-column: 2">${hoursLongContent}</div>`
              : ''
          }
        </div>
      </div>`;

      const infoWindow = new InfoWindow({
        content: infoWindowContent,
      });

      marker.addListener('click', ({ domEvent, latLng }) => {
        const { target } = domEvent;
        infoWindow.close();
        map.setCenter({ lat, lng });
        map.setZoom(15);
        infoWindow.open(marker.map, marker);
      });

      store.querySelector('.view-store').addEventListener('click', () => {
        infoWindow.close();
        map.setCenter({ lat, lng });
        map.setZoom(15);
        infoWindow.open(map, marker);
      });

      bounds.extend({ lat, lng });
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
    }
  }

  initMap();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
